import {ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {OrderService} from "../../../../services/OrderService";
import {ModalController} from "@ionic/angular";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {TicketsListPage} from "../../pages/tickets-list/tickets-list.page";
import {Business} from "../../../../../framework/model/core/business/business";
import {BusinessService} from "../../../../services/BusinessService";
import {AppSettings} from "../../../../conf/appSettings";
import {Events} from "../../../../../framework/providers/events";

@Component({
    selector: 'quick-cart',
    templateUrl: './quick-cart.component.html',
    styleUrls: ['./quick-cart.component.scss'],
})
export class QuickCartComponent implements OnInit, OnDestroy {

    @Input()
    hideCartDetails = true;

    @Input()
    quickOrder = false;

    public business: Business;
    public openTickets = {};
    public cart;
    public cartData;
    public cartStatus;
    public openStatus = {};
    public catalog: boolean;

    public active: boolean = true;

    public settings;
    public appuser;

    public sub_prefix: string = 'sub_' + Math.floor(Math.random() * Math.floor(1000000));

    @ViewChild('cartContent', null) private cartContent: ElementRef;

    constructor(public events: Events,
                public modalController: ModalController,
                public businessService: BusinessService,
                private changeRef: ChangeDetectorRef,
                public appsettings: AppSettings,
                public orderService: OrderService, public modelToolsProvider: ModelToolsProvider) {
        this.business = this.businessService.getBusiness();

        this.catalog = this.businessService.isCatalog();
        this.settings = this.appsettings.getSettings('cart');
        this.appsettings = this.appsettings.getSettings('app');
    }

    ngOnInit() {
        this.events.subscribe('cartUpdated', (res) => {
            this.getCart();
        }, this.sub_prefix);

        this.events.subscribe('cartStatusChanged', (params) => {
            this.getCartStatus();
        }, this.sub_prefix);

        this.events.subscribe('appuserChanged', (params) => {
            this.appuser = this.orderService.getAppUser();
        }, this.sub_prefix);

        this.appuser = this.orderService.getAppUser();

        this.getCart();
        this.getCartStatus();
    }

    ngOnDestroy()
    {
        this.events.unsubscribe('cartUpdated', this.sub_prefix);
        this.events.unsubscribe('cartStatusChanged', this.sub_prefix);
        this.events.unsubscribe('appuserChanged', this.sub_prefix);
    }

    // setCartStatus() {
    //     this.orderService.setCartStatus();
    // }

    getCartStatus() {
        this.cartStatus = this.orderService.getCartStatus();
    }

    getCart() {
        let me = this;
        me.cart = me.orderService.getCart();
        me.cartData = me.orderService.getCartData();

        // //console.logme.cartData)
        // //console.logme.cart)

        if (Object.keys(me.cart).length == 1) {
            //////console.log'open ticket!!!')
            me.openStatus[Object.keys(me.cart)[0]] = true;
        }

        this.changeRef.detectChanges();

        // this.scrollToBottom();
    }

    emptyCart() {
        let me = this;
        this.modelToolsProvider.yesOrNoAlert(function () {
            me.orderService.clearCart();
        })
    }

    proceed() {
        if (!this.appuser) {
            this.modelToolsProvider.goTo('login');
            return
        }
        this.hideCartDetails = false;
    }

    async showTickets() {
        if (!this.cartData['tickets']) return;
        const modal = await this.modalController.create({
            component: TicketsListPage,
            componentProps: {}
        });

        return await modal.present();
    }

    // openCloseRoom(name)
    // {
    //     if (this.openRooms.indexOf(name)!=-1)
    //     {
    //         this.openRooms.splice(this.openRooms.indexOf(name))
    //     }
    // }


    scrollToBottom(): void {
        // try {
        this.cartContent.nativeElement.scrollTop = this.cartContent.nativeElement.scrollHeight;
        // } catch(err) { }
    }

}
